import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetDienstleistungPreisListeMutation } from '../../../api/StammdatenAPI';
import { LoadingModal } from '../../../component/LoadingModal/LoadingModal';
import { IDienstleistungPreis } from '../../../types/Types';
import LandingpageHeader from '../../header/LandingpageHeader';
import styles from '../admin.module.scss';
import { formatToEuroDate } from '../../../util/DateUtils';

export default function PreiseMain() {

  const [loading, setLoading] = useState(false);
  const [liste, setListe] = useState<IDienstleistungPreis[]>([]);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [getListeApi] = useGetDienstleistungPreisListeMutation();

  const init = () => {
    setLoading(true);
    getListeApi().unwrap()
      .then(data => setListe(data))
      .catch((e) => console.log(e))
      .finally(() => setLoading(false));
  }

  useEffect(() => {
    init();
  }, []);

  return (
    <>
      <div className={classNames(styles.centerContainer)}>

        <LandingpageHeader />

        <div className='container' >

          <button
            onClick={() => {
              navigate({
                pathname: "/",
                search: ""
              });
            }}

            style={{ marginBottom: "20px" }}
            className=' btn btn-outline-primary'
          >
            <i className="bi bi-arrow-left"></i> {t('deTranslation.auftragDetails.backButton')}
          </button>

          <div className={styles['wg-detail-ueb']}>
            <div><span style={{ fontSize: "28pt", fontWeight: "700" }}>Preise</span></div>
            <div style={{ textAlign: "end" }}></div>
          </div>
          <button className="btn btn-primary" onClick={() => navigate('detail', { state: { view: 'create' } })}><i className="bi bi-plus"></i><span style={{ marginLeft: "1em" }}>NEU ANLEGEN</span></button>

          <div style={{ display: "grid", fontWeight:"bold", gridTemplateColumns: "2fr 3fr 1fr 1fr 40px", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
            <div>Auftraggeber</div>
            <div>Dienstleistung</div>
            <div>Preis</div>
            <div>Gültig ab</div>
            <div style={{ textAlign: "end" }}>
              Option
            </div>
          </div>
          {
            (!loading && liste?.map((e, index) =>
              <div key={index} style={{ display: "grid", gridTemplateColumns: "2fr 3fr 1fr 1fr 40px", gap: "10px", alignItems: "center", padding: "10px", marginTop: "10px", border: "1px solid #ccc" }}>
                <div>{e.auftraggeber?.name ?? "ALLE KUNDEN"}</div>
                <div>{e.dienstleistung.text}</div>
                <div>{e.preis}</div>
                <div>{formatToEuroDate(e.gueltigAb)}</div>
                <div style={{ textAlign: "end" }}>
                  <button onClick={() => navigate('detail', { state: { view: 'detail', id: e.uid } })} className={styles["wg-a"]} ><i className="bi bi-pencil"></i></button>
                </div>
              </div>)
            )
          }

        </div>

        <LoadingModal show={loading} text="Bitte warten..." />
      </div>

    </>
  );
}